const MenuBox=()=>
    {
        return (
            <div class="box_menu">
  
            <nav id="menu" class="menu">
              <ul>
                <li class="icon_menu active"><a href="gioi-thieu" title="Giới thiệu chung">Giới thiệu chung</a>
                               <ul>
                      <div class="container_main">
                                          <li><a href="tam-nhin-su-mang" title="TẦM NHÌN - SỨ MẠNG"><i class="far fa-angle-right"></i> TẦM NHÌN - SỨ MẠNG</a>
                          </li>
                                          <li><a href="gia-tri-cot-loi" title="GIÁ TRỊ CỐT LÕI"><i class="far fa-angle-right"></i> GIÁ TRỊ CỐT LÕI</a>
                          </li>
                                          <li><a href="lich-su-hinh-thanh-phat-trien" title="LỊCH SỬ HÌNH THÀNH PHÁT TRIỂN"><i class="far fa-angle-right"></i> LỊCH SỬ HÌNH THÀNH PHÁT TRIỂN</a>
                          </li>
                                          <li><a href="co-so-dao-tao" title="CƠ SỞ ĐÀO TẠO"><i class="far fa-angle-right"></i> CƠ SỞ ĐÀO TẠO</a>
                          </li>
                                          <li><a href="thanh-tuu" title="THÀNH TỰU"><i class="far fa-angle-right"></i> THÀNH TỰU</a>
                          </li>
                                          <li><a href="triet-li-giao-duc" title="TRIẾT LÍ GIÁO DỤC"><i class="far fa-angle-right"></i> TRIẾT LÍ GIÁO DỤC</a>
                          </li>
                                          <li><a href="ban-giam-hieu" title="BAN GIÁM HIỆU"><i class="far fa-angle-right"></i> BAN GIÁM HIỆU</a>
                          </li>
                                          <li><a href="phong-ban-trung-tam" title="KHOA/PHÒNG/TRUNG TÂM"><i class="far fa-angle-right"></i> KHOA/PHÒNG/TRUNG TÂM</a>
                          </li>
                                      </div>
                    </ul>
                          </li>
                <li class="icon_menu "><a href="chuong-trinh-hoc" title="Chương trình học">Chương trình học</a>
                              <ul>
                      <div class="container_main">
                                          <li><a href="dao-tao-cu-nhan" title="Đào tạo đại học"><i class="far fa-angle-right"></i> Đào tạo đại học</a>
                          </li>
                                          <li><a href="dao-tao-sau-dai-hoc" title="Đào tạo sau đại học"><i class="far fa-angle-right"></i> Đào tạo sau đại học</a>
                          </li>
                                          <li><a href="dao-tao-van-bang-2" title="ĐÀO TẠO VĂN BẰNG 2"><i class="far fa-angle-right"></i> ĐÀO TẠO VĂN BẰNG 2</a>
                          </li>
                                          <li><a href="khung-chuong-trinh-dao-tao" title="KHUNG CHƯƠNG TRÌNH ĐÀO TẠO"><i class="far fa-angle-right"></i> KHUNG CHƯƠNG TRÌNH ĐÀO TẠO</a>
                          </li>
                                          <li><a href="de-an-mo-nganh" title="ĐỀ ÁN MỞ NGÀNH"><i class="far fa-angle-right"></i> ĐỀ ÁN MỞ NGÀNH</a>
                          </li>
                                          <li><a href="tap-chi-kh-oa-hoc" title="TẠP CHÍ KHOA HỌC"><i class="far fa-angle-right"></i> TẠP CHÍ KHOA HỌC</a>
                          </li>
                                      </div>
                    </ul>
                          </li>
                <li class="icon_menu "><a href="trai-nghiem-sinh-vien" title="Trải nghiệm sinh viên">Trải nghiệm sinh viên</a>
                              <ul>
                      <div class="container_main">
                                          <li><a href="thong-bao" title="THÔNG BÁO"><i class="far fa-angle-right"></i> THÔNG BÁO</a>
                          </li>
                                          <li><a href="hoat-dong-sinh-vien" title="HOẠT ĐỘNG SINH VIÊN"><i class="far fa-angle-right"></i> HOẠT ĐỘNG SINH VIÊN</a>
                          </li>
                                      </div>
                    </ul>
                          </li>
                <li class="icon_menu "><a href="goc-truyen-thong" title="Góc truyền thông">Bản tin &amp; sự kiện</a>
                              <ul>
                      <div class="container_main">
                                          <li><a href="hop-tac-cung-gdu-1" title="Góc báo chí"><i class="far fa-angle-right"></i> Góc báo chí</a>
                          </li>
                                          <li><a href="tap-chi-khoa-hoc" title="TẠP CHÍ KHOA HỌC"><i class="far fa-angle-right"></i> TẠP CHÍ KHOA HỌC</a>
                          </li>
                                      </div>
                    </ul>
                          </li>
                <li class="icon_menu "><a href="doanh-nghiep" title="Tuyển Dụng -  Việc Làm">Tuyển Dụng -  Việc Làm</a>
                              <ul>
                      <div class="container_main">
                                          <li><a href="tuyen-dung-gdu" title="Tuyển Dụng GDU "><i class="far fa-angle-right"></i> Tuyển Dụng GDU </a>
                          </li>
                                      </div>
                    </ul>
                          </li>
              </ul>
            </nav>
          </div>
        
        );

    }




export default MenuBox;